//import config from '../config';
import React,{Component} from "react";
import Cookies from "universal-cookie"
import {withRouter} from "react-router-dom";
import NumberFormat from 'react-number-format';
import logo from "./images/loading.gif";
import BusyModal from './modalwait';

const axios = require("axios");
const ref = React.createRef();
const cookies=new Cookies();


class B_form extends Component{
    constructor(props)
    {
        super(props);
           this.state={ErrMsg2:"",defaultimage:config.Appdir+"/images/NoImage.png"};
           this.state={ErrMsg2:"",logo2:"",inputkey:Date.now(),input:{},bdisabled:false,isLoaded:true,errorprofile:"",errors:{},error:"",ErrMsg:<img src={logo} alt=""/>,errorcss:"labelerror",imagefile:config.Appdir+"/images/NoImage.png",filetoupload:null,filename:null,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone",defaultimage:config.Appdir+"/images/NoImage.png"};
           this.handleChange = this.handleChange.bind(this);
           this.handleImageUpload = this.handleImageUpload.bind(this);
           this.handleImage = this.handleImage.bind(this);
    }
    handleImageUpload = async () => 
    {
        if(this.state.filetoupload !== null)
        {
            document.body.style.cursor ="wait";
            this.setState({ErrMsg2:<BusyModal/>});
            const formdata = new FormData() 
            formdata.append("image[]", this.state.filetoupload,this.state.filename);
            formdata.append("image[]",this.state.filetoupload,cookies.get("LoginID"));
            try 
            {
                const response = await axios.post(cookies.get("phpclass")+'/index.php/user/upload_bform/',
                formdata
                );
                this.setState({inputkey:Date.now(),filetoupload: "",filename: "",browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});    
                if(response.data === 2)
                {                    
                    document.body.style.cursor ="default";
                    this.setState({error:"Image has been successfully uploaded",errorcss:"lmagesave",ErrMsg2:""});
                } 
                else                
                {
                    document.body.style.cursor ="default";
                    this.setState({error:"Error: Image upload failed",errorcss:"lmageerror",ErrMsg2:""});
                }                   
            } 
            catch (ex) 
            {
                document.body.style.cursor ="default";
                this.setState({error:ex,errorcss:"lmageerror",ErrMsg2:""});
            }

        }
    }        

    Imagechange=(event)=>
    {
        if(event.target.files[0].size > 512000)
        {
            this.setState({error:"Error: File size exceeded",errorcss:"labelerror"});
            this.setState({inputkey:Date.now()});
        }
        else
        {
            this.setState({error:"",filetoupload: event.target.files[0],filename: event.target.files[0].name,logo2:URL.createObjectURL(event.target.files[0]), imagefile:URL.createObjectURL(event.target.files[0]),browsecss:"labelnone",savecss:"labelblock",cancelcss:"labelblock"});
        }
    }
    Imagecancel=(event)=>
    {       
        this.setState({inputkey:Date.now(),error:"",filetoupload: "",filename: "",imagefile:this.state.defaultimage,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});
    }

    componentDidMount()
    {
        let id=cookies.get("LoginID");
        let bformpath="";
        if(id.length > 1)
        {
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/get_bformpath/'+id,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
//                console.log(response.data);
                bformpath=response.data;
                this.setState({logo2:response.data});
                document.body.style.cursor="default";
            })
            .catch(()=> {

                //handle error
                // this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});

            }); 


            document.body.style.cursor="wait";
            let input = this.state.input;
            input["id"]=id;
            let rn=Math.random(3);

            //this.setState({ logo2: bformpath});
            let imgfile = bformpath+"?ver=" + rn;
            this.setState({imagefile:imgfile});
        }
    }
    handleChange=(event)=> 
    {
        this.setState({imagefile:this.state.defaultimage});
    }
    //Change of input fields
    handleFiledsChange=(event)=>
    {
        let input = this.state.input;
        input[event.target.name]=event.target.value;
        this.setState({input});
       
    }
   handleImage = (e) => {

        const file = e.target.files[0];

        if (file) {

            const reader = new FileReader();

            reader.onload = () => {
                this.setState({
                    logo2: reader.result
                });
            };

            reader.readAsDataURL(file);
        }
    }
   
    render(){
        let myimage=this.state.logo2;
        return(
                <div className="containera1">
                    <br></br>                             
                <div width="50%" align="center" scroll="hidden" backgroundColor="#a39b9b">
                        <span className="box-title">B-Form</span>
                        <div width="60%" align="center" style={{paddingTop:"10px"}} backgroundColor="#989393" scroll="hidden">
                            <img src={myimage}  onError={this.handleChange} style={{width:"340px",height:"420px",paddingTop:"0px",marginTop:"5px",Left:"0%",border: "1px solid #555"}} alt=""></img>
        
                        </div>
                            <label style={{fontSize:"8pt",width:"173px",textAlign:"center"}}>Max size=512KB </label>
                            <label className={this.state.browsecss}>

                            <input type="file" name="file" key={this.state.inputkey} accept="image/*" className="upload" onChange={this.Imagechange} style={{width:"173px",height:"20px",border: "0px"}}/>
                            <span>Browse B-Form </span>
                            </label>

                            <label className={this.state.savecss}>
                            < button onClick={this.handleImageUpload} style={{border: "0px"}}>
                                <span>Save B-Form</span>
                            </button>
                            </label>
                            <label className={this.state.cancelcss}>
                            <button  onClick={this.Imagecancel} style={{border: "0px"}}>
                                <span>Cancel</span>
                            </button>
                            </label>
                            <div style={{width:"350px",textAlign:"center"}}>
                                <span className={this.state.errorcss}>{this.state.error}</span>
                            <label style={{fontSize:"8pt",width:"173px",textAlign:"center"}}>{this.state.ErrMsg2} </label>
                            </div>
                        
                            
                </div>
                        </div>

        
    );}
}
export default withRouter(B_form);